import React from 'react';
import styled from 'styled-components';

const Radio = styled.div`
	width: 25px;
	height: 25px;
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	font-size: 10px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
	}

	.checkmark {
		//position: absolute;
		top: 0;
		left: 0;
		height: 20px;
		width: 20px;
		background-color: ${props => props.theme.Cool_Gray_Light_3};
		border-radius: 50%;
		box-shadow: -1.5px -1.5px 3px 0 #ffffff;
	}

	:hover input ~ .checkmark {
		//background-color: #ccc;
	}

	input:checked ~ .checkmark {
		// background-color: ${props => props.theme.Bright_Blue};
		// filter: blur(1px);
	}

	.checkmark:after {
		content: '';
		position: absolute;
		display: none;
	}

	input:checked ~ .checkmark:after {
		display: block;
	}

	.checkmark:after {
		top: 4px;
		left: 3px;
		width: 17px;
		height: 17px;
		border-radius: 50%;
		background-color: ${props => props.theme.Bright_Blue};
		filter: blur(1px);
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		margin-top: 10px;
	}
`;

export const RadioCheckBox = ({ checked, onClickFunc, id, cypressId }) => {
	function handleChange() {
		onClickFunc();
	}

	return (
		<Radio id={id} className='custom-radio-button' data-cy={cypressId}>
			<input id={id} name={id} type='radio' checked={checked} onClick={handleChange} />
			<span class='checkmark' onClick={handleChange}></span>
		</Radio>
	);
};

// RadioCheckBox.propTypes = {
// 	children: any,
// 	className: string,
// 	id: string,
// 	onClick: func,
// 	onMouseOver: func,
// 	module: string,
// 	cypressId: string,
// 	enabled: bool,
// 	breakpoint: number.isRequired,
// 	svgId: string,
// };

// RadioCheckBox.defaultProps = {
// 	children: '',
// 	className: 'action-button',
// 	id: 'action-button',
// 	onClick: () => {},
// 	onMouseOver: () => {},
// 	module: 'support',
// 	cypressId: 'icon-button',
// 	enabled: true,
// 	svgId: 'unique-svg-id',
// };
